// Copied from resources/js/routes/rfq/bid_requests/_select_item.js
// Would be nice to adjust this to wherever it's doing something with window.opener's document, we instead run abcetup.loadRouteJS('itemsSelected')
// and add the ability to pass values with loadRouteJS().
///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.item = abcsetup.consumer_rfp.item || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.item.item_selector = {
    items: [],
    removeItems: [],
    itemsSelect: null,

    init() {
        abcsetup.setTitle('Item Selector');

        this.itemsSelect = $('#app_a_b_c_item__item_ids', window.opener.document);

        // Populate selected checkboxes in the array
        this.itemsSelect
            .find('option:selected')
            .toArray()
            .forEach(itemOption => this.items.push({
                    id: $(itemOption).val(),
                    text: $(itemOption).text()
                })
            );

        this._setupEventBindings();
        this._initDataTable();
        this._updateAttachButtonText();
    },

    _initDataTable() {
        abcsetup.blockUI(true);

        // init datatables
        const table = abcsetup.datatables.init($('#existing_items'), {
            bInfo: true,
            scroll_horizontal: true,
            pagingType: 'input',
            responsive: false,
            lengthMenu: [[5, 10, 25, 50, 100, 1000], [5, 10, 25, 50, 100, 1000]],
            iDisplayLength: 5,
            order: [[3, 'asc']],
            stateSave: false,
            serverSide: true,
            resetTable: false,
            reorderRedraw: true, // Redraw the table when a column re-order happens

            ajax: '/api/consumer_rfp/item/item_selector_table',
            columns: [
                {name: 'checkbox', orderable: false, searchable: false},
                {name: 'id', searchable: false},
                {name: 'mat_descr'},
                {name: 'abbr_descr'},
                {name: 'ext_descr'},
                {name: 'mat_eff_date'},
                {name: 'sap_mat_create_date'},
                {name: 'sap_num'},
                {name: 'division'},
                {name: 'upc'},
                {name: 'ndc11'},
                {name: 'item_hri'},
                {name: 'retail_upc'},
                {name: 'vc'},
                {name: 'abc_6_digit'},
                {name: 'abc_matl_replace'},
                {name: 'qualifier_code'},
                {name: 'mat_group'},
                {name: 'mat_status'},
                {name: 'program_code'},
                {name: 'vendor_name'},
                {name: 'vendor'},
                {name: 'category_name'},
                {name: 'subcategory_name'},
                {name: 'segment_name'},
                {name: 'form'},
                {name: 'unit_size'},
                {name: 'unit_str'},
                {name: 'unit_dose_code'},
                {name: 'order_unit'},
                {name: 'mfr_prod_code'},
                {name: 'case_pack_qty'},
                {name: 'wac'},
                {name: 'last_ship_date'},
                {name: 'first_ship_date'},
                {name: 'planogram'},
                {name: 'pog_predom'},
            ],

            // Table has been drawn/paginated
            drawCallback(settings) {
                const btnAttachAll = $('.btn-attach-all');
                // Check any selected item checkboxes
                abcsetup.consumer_rfp.item.item_selector.items.forEach(item => {
                    $('#existing_items input:checkbox[value=' + item.id + ']').addClass('selected').prop('checked', true);
                });

                const total = this.api().page.info().recordsDisplay;
                btnAttachAll.html("Select All (" + abcsetup.addCommas(total) + ")").attr('disabled', true);

                btnAttachAll.attr('disabled', !total || total >= 2000);
            }
        });

        // This is a hack to fix an issue with the headers being aligned with their columns.
        window.setTimeout(() => table.draw(), 1200);
    },

    _setupEventBindings() {
        // ABC Item checkbox checked
        $(document).on('change', 'input:checkbox', event => {
            $(event.target).removeClass('selected');

            if ($(event.target).prop('checked')) {
                this.items.push({
                    id: $(event.target).val(),
                    text: $(event.target).data('name')
                });
            } else {
                this.items = this.items.filter(obj => obj.id !== $(event.target).val());

                // We need to keep track of items to remove
                this.removeItems.push($(event.target).val());
            }

            this._updateAttachButtonText();
        });

        // Attach button clicked
        $(document).on('click', '.btn-attach', () => {
            // Attach the newly selected items
            this.items.forEach(item => {
                // Toggle the existing item or add it
                if (this.itemsSelect.find(`option[value=${item.id}]`).length) {
                    this.itemsSelect.find(`option[value=${item.id}]`).prop('selected', true);
                } else {
                    const newOption = new Option(item.text, item.id, true, true);
                    this.itemsSelect.append(newOption);
                }
            });

            // Remove items (if necessary)
            this.removeItems.forEach(itemId => {
                this.itemsSelect.find(`option[value=${itemId}]`).remove();
            });

            // Cannot use $().trigger('change') for some reason, so using plain JS event dispatching.
            this.itemsSelect.get(0).dispatchEvent(new Event('change'))

            window.close();
        });

        // Attach all button clicked
        $(document).on('click', '.btn-attach-all', event => {
            abcsetup.blockUI(true);

            const _link = $(event.target);
            _link.css('cursor', 'progress');

            // Get all the records in the current datatable
            abcsetup.datatables.exportAjaxTable('RECORDS', abcsetup.datatables.table, false);
            axios.post('/api/consumer_rfp/item/item_selector_table?action=EXPORT_RECORDS', $('#datatables_download').serialize()).then(response => {
                _link.css('cursor', 'pointer');

                // Clear out currently selected items.
                this.itemsSelect.find('option').remove();

                if (response.data && response.data.data) {
                    response.data.data.forEach(item => {
                        const checkBox = $(item[0]).find('input[type=checkbox]');
                        const id = checkBox.val();
                        const name = checkBox.data('name');

                        const newOption = new Option(name, id, true, true);
                        this.itemsSelect.append(newOption);
                    });

                    // Cannot use $().trigger('change') for some reason, so using plain JS event dispatching.
                    this.itemsSelect.get(0).dispatchEvent(new Event('change'))

                    window.close();
                }
            });
        });

        // Cancel button clicked
        $(document).on('click', '.btn-cancel', () => window.close());
    },

    _updateAttachButtonText() {
        $('.btn-attach')
            .text(`Update Selected Items (${this.items.length})`)
            .attr('disabled', this.items.length === 0);
    }
}
